import APIClient from '@/shared/http/clients/api'

const resourceName = 'REEmpreendimentoTourVirtual'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const SaveLinkTour = (id, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/SaveLinkTour/${id}`, data, config)
const GetTourVirtualByUnidadeTipoIdAndEmpreendimentoid = (empreendimentoid, id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetTourVirtualByUnidadeTipoIdAndEmpreendimentoid/${empreendimentoid}/${id}`, data, config)

const VirtualTourentErpriseRepository = {
  SaveLinkTour,
  GetTourVirtualByUnidadeTipoIdAndEmpreendimentoid

}

export default VirtualTourentErpriseRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/virtualtourenterprise.js